module.exports = __webpack_public_path__ + "static/img/other_FAQ_pic02.2a60198.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other_FAQ/other_FAQ_pic02.png
// module id = 554
// module chunks = 1